<div #divSpinner class="cargando" [style.display]="cargando ? '' : 'none'">
    <mat-spinner style="margin:0 auto; margin-top: 15%;"></mat-spinner>
</div>

<div class="customers">
    <div class="card">
        <div class="card-body" style="padding: 20px;">
            <div class="row">
                <div class="col-sm-6">
                    <p class="titulo-card-naranja">Evaluación</p>
                </div>
                <div class="col-sm-6" style="text-align: right;">
                    <button type="button" class="btn btn-light btn-volver" style="background: #FF8685 0% 0% no-repeat padding-box;color: #FFEEEE;" (click)="guardarEvaluacion()" *ngIf="guardarEditar && !simulacion"> Guardar</button>
                    <button type="button" class="btn btn-light btn-volver" *ngIf="simulacion" (click)="volver2()"> Volver</button>
                    <button type="button" class="btn btn-light btn-volver" *ngIf="!simulacion" (click)="volver()"> Volver</button>
                </div>
            </div>


            <div class="row">
                <div class="col-sm-6" style="border-right: 1px solid #E8E8E8;">
                    <div class="row">
                        <div class="col-sm-6">

                        </div>
                        <div class="col-sm-6" style="text-align: right;">
                            <p style="margin-right: 10px;
                            font: normal normal bold 16px/20px Montserrat;
                            letter-spacing: 0px;
                            color: #3A445E;
                            text-transform: uppercase;
                            
                            opacity: 1;">Contexto Institucional</p>
                        </div>
                    </div>

                    <div class="row" style="padding: 15px;">
                        <div class="col-sm-12" style="background: #F6F6F6 0% 0% no-repeat padding-box;border-radius: 10px;opacity: 1;padding: 15px;text-align: justify;">
                            <p>Todo programa, proyecto o acción debe ser monitoreado y evaluado en función de los objetivos y compromisos señalados en el ideario.</p>
                            <p>Con relación a la evaluación de los objetivos estratégicos del jardín infantil se realizará un seguimiento a las acciones derivadas de éstos y al cumplimiento de los indicadores de gestión emanados de la institución, ya sea a nivel regional, nacional o local para levantar las acciones de mejora.</p> 
                            <p>Además de las evaluaciones para el aprendizaje de los niños y niñas, se fijarán indicadores de evaluación respecto al porcentaje de madres jefas de hogar, matrícula y asistencia, párvulos con entrevistas de retroalimentación (entre educadora de párvulos y padres), del estado nutricional (peso y talla) de niños y niñas y de accidentabilidad de los párvulos.</p>
                            <br>
                          
                        </div>
                    </div>

                </div>
                <div class="col-sm-6">
                    <div class="row">
                        <div class="col-sm-6">
                            <p style="text-align: left;
                            font: normal normal bold 16px/20px Montserrat;
                            letter-spacing: 0px;
                            color: #3A445E;
                            text-transform: uppercase;
                            margin-left: 10px;
                            opacity: 1;">Contexto Unidad Educativa</p>
                        </div>
                        <div class="col-sm-6" style="text-align: right;">

                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12">
                            <p style="text-align: left;font: normal normal bold 12px/19px Montserrat;letter-spacing: 0px; margin-left: 15px; color: #FF8685;text-transform: uppercase;opacity: 1;">Seguimiento</p>
                        </div>
                    </div>
                    <div class="row" style="padding: 15px;">
                        <div class="col-sm-12">
                            <mat-form-field class="w-100" hintLabel="Max. 5000 caracteres">
                                <textarea
                                rows="8" 
                                cols="20" 
                                class="text-area-ideario" 
                                style="height: 570px;"
                                maxlength="5000"
                                autocomplete="off"
                                matInput
                                [disabled]="!guardarEditar"
                                id="seguimiento"
                                name="seguimiento"
                                (change)="change()"
                                [(ngModel)]="this.proyectoEducativoEvaluacionDataModel.seguimiento"
                                ></textarea>
                                <mat-hint align="end">{{this.proyectoEducativoEvaluacionDataModel.seguimiento.length || 0}}/5000</mat-hint>
                            </mat-form-field>  
                            <mat-error *ngIf="this.proyectoEducativoEvaluacionDataModel.seguimiento.length>4999">Max. caracteres alcanzado</mat-error>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12">
                            <p style="text-align: left;font: normal normal bold 12px/19px Montserrat;letter-spacing: 0px; margin-left: 15px;color: #FF8685;text-transform: uppercase;opacity: 1;">Proyecciones</p>
                        </div>
                    </div>
                    <div class="row" style="padding: 15px;">
                        <div class="col-sm-12">
                            <mat-form-field class="w-100" hintLabel="Max. 5000 caracteres">
                                <textarea
                                rows="8" 
                                cols="20" 
                                class="text-area-ideario" 
                                style="height: 570px;"
                                maxlength="5000"
                                autocomplete="off"
                                matInput
                                [disabled]="!guardarEditar"
                                id="proyecciones"
                                name="proyecciones"
                                (change)="change()"
                                [(ngModel)]="this.proyectoEducativoEvaluacionDataModel.proyecciones"
                                ></textarea>
                                <mat-hint align="end">{{this.proyectoEducativoEvaluacionDataModel.proyecciones.length || 0}}/5000</mat-hint>
                            </mat-form-field>  
                            <mat-error *ngIf="this.proyectoEducativoEvaluacionDataModel.proyecciones.length>4999">Max. caracteres alcanzado</mat-error>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>